import _ from 'lodash'

export const sanitize = function (value) {
  try {
    var pattern = /[^-a-z@A-Z0-9_]+/gi
    let sanate = value
    sanate = _.replace(String(sanate).trim(), ' ', '_')
    sanate = sanate.replace(pattern, '_').toLowerCase()
    return sanate
  } catch {
    return ''
  }
}
